import React from 'react';
import { Button, Divider, IconButton, Modal, Paper, Stack, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

const modalPaperSx = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  p: 2,
  outline: 'none',
  bgcolor: 'background.paper',
  border: 1,
  borderColor: 'divider',
};

export default function RoleDeleteDialog({ open, onClose, onSubmit, isDeleting }) {
  const confirmMessage = 'Deleting this role will remove its permissions from users assigned to it.';

  return (
    <Modal open={open} onClose={onClose}>
      <Paper elevation={0} sx={modalPaperSx}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Delete Role?</Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Stack>
        <Divider sx={{ my: 1 }} />
        <Typography variant="body1" sx={{ my: 2 }}>
          {confirmMessage}
        </Typography>
        <Stack direction="row" sx={{ justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={onSubmit} disabled={isDeleting}>
            Delete
          </Button>
        </Stack>
      </Paper>
    </Modal>
  );
}
